
const digest = 'e2c2164d8371483881ed9bca9e79375ef89c75a7d557e2a2db5342fc62c236ed';
const classes = {"wrapper":"_wrapper_1krvq_1"};
const css = `._wrapper_1krvq_1 {
  border: 1px solid #e2e5ed;
  height: 100%;
  padding: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  